import { createSlice } from "@reduxjs/toolkit";
import { UserEntity } from "../../services/users/user.types";

export type AuthState = {
  token: string;
  user: UserEntity | null;
  // "Administrador principal" (SCRUM-706). Kept beside the user instead of
  // inside UserEntity: it is an Admin Emmi privilege, not a property of the
  // user rows the CRUD screens render.
  isSuperAdmin: boolean;
};

const initialState: AuthState = {
  token: "",
  user: null,
  isSuperAdmin: false,
};

const auth = createSlice({
  name: "auth",
  initialState,
  reducers: {
    cleanAuth: () => {
      return {
        token: "",
        user: null,
        isSuperAdmin: false,
      };
    },
    setAuth: (state, action) => {
      return {
        token: action.payload.token,
        user: action.payload.user,
        isSuperAdmin: !!action.payload.isSuperAdmin,
      };
    },
  },
});

export default auth;
